import React, { FC } from 'react'
import { createUseStyles } from 'react-jss'
import { RefreshIcon } from '../../icons/refresh-icon/RefreshIcon'
import { StyledIcon } from '../../styled-icon/StyledIcon'

type StyledRefreshIconProps = {}

export const StyledRefreshIcon: FC<StyledRefreshIconProps> = () => {

	// hooks
	const styles = useStyles()

	return (
		<StyledIcon
			icon={RefreshIcon}
			colors={{
				background: '#D16B3D',
				foreground: '#FFF9F7',
			}}
		/>
	)
}

const useStyles = createUseStyles({
	styledRefreshIcon: {
		display: 'grid'
	}
})